/**
 * What the Members screens' kit Selects hold (#1223). The native selects they replaced said "nothing picked" and
 * "no role on that team" with an empty value; the kit Select (Reka) refuses an item whose value is the empty
 * string, so "no role on that team" is held as this value instead and turned back into `null` before anything is
 * sent. Role ids are UUIDs, so no role can ever be mistaken for it.
 */
export const NO_ROLE_ON_TEAM = 'no-role-on-team'

/** The id a kit Select's model update carries, as the string the screen holds: empty when nothing is picked. */
export function pickedId(choice: unknown): string {
    return choice === null || choice === undefined ? '' : String(choice)
}

/** The role a team join sends: the role picked beside the team, or `null` when none was (or no choice at all). */
export function teamRoleOf(choice: unknown): string | null {
    const roleId = pickedId(choice)
    return roleId === '' || roleId === NO_ROLE_ON_TEAM ? null : roleId
}
